import angular from 'angular';
import weeklyTimesheetTemplate from './weekly-timesheet.html';

function toDragType(ev) {
  let type = ev.dataTransfer.types[ev.dataTransfer.types.length - 1];
  const data = ev.dataTransfer.getData(type);

  if (type === 'Text') {
    const index = data.indexOf('\t');
    if (index > 0) {
      type = data.substring(0, index);
    }
  }
  return type;
}

function toDragDataAndType(ev) {
  let type = ev.dataTransfer.types[ev.dataTransfer.types.length - 1];
  let data = ev.dataTransfer.getData(type);

  if (type === 'Text') {
    const index = data.indexOf('\t');
    if (index > 0) {
      type = data.substring(0, index);
      data = data.substring(index + 1);
    }
  }

  try {
    data = JSON.parse(data);
  } catch (e) {
    type = 'Text';
  }

  return { data, type };
}

class WeeklyTimesheetController {
  static $inject = [
    '$scope',
    '$filter',
    '$state',
    '$stateParams',
    '$timeout',
    'CalendarService',
    'Timerecord',
    'toastr',
    '$modal',
    'AuthService',
  ];

  currentUser: any;
  selectedUser: any;
  selectedDate: any;
  week: any;
  timerecords: any[] = [];
  firstIncompleteWeek: any;
  isFirstIncompleteWeek: boolean = false;
  status: any = {};

  constructor(
    private $scope,
    private $filter,
    private $state,
    private $stateParams,
    private $timeout,
    private CalendarService,
    private Timerecord,
    private toastr,
    private $modal,
    private AuthService,
  ) {}

  $onInit() {

    this.AuthService.me().then((currentUser) => {
      this.currentUser = currentUser;
    });

    const parentCtrl = this.$scope.$parent && this.$scope.$parent.$ctrl;
    const selectedUser = parentCtrl
      ? parentCtrl.selectedUser
      : this.$scope.$parent && this.$scope.$parent.selectedUser;

    if (selectedUser) {
      this.init(selectedUser);
    }

    this.$scope.$on('user:selected', () => {
      const selected =
        this.$scope.$parent && this.$scope.$parent.$ctrl
          ? this.$scope.$parent.$ctrl.selectedUser
          : this.$scope.$parent.selectedUser;
      if (selected) {
        this.init(selected);
      }
    });
  }

  private init(user) {
    this.selectedUser = user;
    this.selectedDate = this.CalendarService.getWeekOfYear(
      this.$stateParams.year,
      this.$stateParams.week,
    );

    const from = this.CalendarService.getWeekOfYear(
      this.$stateParams.year,
      this.$stateParams.week,
    );
    const to = this.CalendarService.getWeekOfYear(
      this.$stateParams.year,
      this.$stateParams.week,
    ).add(4, 'days');

    this.week = this.CalendarService.getWeek(
      this.$stateParams.year,
      this.$stateParams.week,
    );
    this.timerecords = this.Timerecord.query({
      memberId: user.id,
      from: from.format('YYYY-MM-DD'),
      to: to.format('YYYY-MM-DD'),
    });

    this.$timeout(() => {
      this.Timerecord.firstIncompleteDay({
        memberId: user.id,
      }).then((day) => {
        const firstIncompleteDay = moment(day.date);
        this.firstIncompleteWeek = this.CalendarService.getWeekOfYear(
          firstIncompleteDay.year(),
          firstIncompleteDay.week(),
        );
        this.isFirstIncompleteWeek =
          firstIncompleteDay.week() == this.$stateParams.week &&
          firstIncompleteDay.year() == this.$stateParams.year;
      });
    });
  }

  private getYear(date) {
    if (date) {
      const week = moment(date).startOf('week');
      return week.add(3, 'days').year();
    }
    return null;
  }

  private getWeek(date) {
    if (date) {
      const week = moment(date).startOf('week');
      return week.week();
    }
    return null;
  }

  getPrevious() {
    const previousWeek = this.CalendarService.getWeekOfYear(
      this.$stateParams.year,
      this.$stateParams.week,
    ).subtract(1, 'weeks');
    return {
      userId: this.$stateParams.userId,
      year: this.getYear(previousWeek),
      week: previousWeek.week(),
    };
  }

  getNext() {
    const nextWeek = this.CalendarService.getWeekOfYear(
      this.$stateParams.year,
      this.$stateParams.week,
    ).add(1, 'weeks');
    return {
      userId: this.$stateParams.userId,
      year: this.getYear(nextWeek),
      week: nextWeek.week(),
    };
  }

  gotoWeek() {
    this.$state.go('.', {
      userId: this.$stateParams.userId,
      year: this.getYear(this.selectedDate),
      week: this.getWeek(this.selectedDate),
    });
  }

  private totalDuration(day) {
    let total = 0;
    if (this.timerecords) {
      const dailyTimerecords = this.$filter('day')(this.timerecords, day);
      dailyTimerecords.forEach(function (record) {
        if (!record.dragged) {
          total += record.duration;
        }
      });
    }
    return total;
  }

  isDayFull(day) {
    return 100 - this.totalDuration(day) == 0;
  }

  isDurationFull(day, duration) {
    return 100 - this.totalDuration(day) < duration;
  }

  dragOverDuration = (event, theMoment, duration) => {
    if (this.isDurationFull(theMoment, duration)) {
      event.dataTransfer.dropEffect = 'none';
    } else if (this.totalDuration(theMoment.day()) + duration > 100) {
      event.dataTransfer.dropEffect = 'none';
    }
  };

  dropOnDuration = (event, theMoment, duration) => {
    const dataAndType = toDragDataAndType(event);
    const dataType = dataAndType.type;
    const dropped = dataAndType.data;

    if (dataType == 'application/x-timerecord.timerecord+json') {
      this.updateOrIncreaseTimerecord(theMoment, duration, dropped);
    } else {
      this.createOrIncreaseTimerecord(theMoment, duration, dropped);
    }
  };

  dragOverWeek = (event) => {
    const type = toDragType(event);

    if (type !== 'application/x-timerecord.activity+json') {
      event.dataTransfer.dropEffect = 'none';
    } else {
      let total = 0;
      this.timerecords.forEach(function (timerecord) {
        total += timerecord.duration;
      });

      if (total == 500) {
        event.dataTransfer.dropEffect = 'none';
      }
    }
  }

  private findExistingTimerecord(theMoment, activity) {
    const dayRecords = this.$filter('day')(
      this.timerecords,
      theMoment.day(),
    );
    return dayRecords.find(
      (timerecord) => timerecord.activity.id === activity.id,
    );
  }

  private updateOrIncreaseTimerecord(theMoment, duration, timerecord) {
    const updatedTimerecord = this.timerecords.filter(function (element) {
      return element.id === timerecord.id;
    })[0];

    const isSameDay = theMoment.isSame(moment.utc(updatedTimerecord.date));

    if (!isSameDay || duration != updatedTimerecord.duration) {
      const existingTimerecord = this.findExistingTimerecord(
        theMoment,
        updatedTimerecord.activity,
      );

      if (!isSameDay && existingTimerecord) {
        existingTimerecord.duration += duration;
        existingTimerecord.comment += updatedTimerecord.comment;

        this.Timerecord.update(
          existingTimerecord,
          () => {
            this.Timerecord.remove(
              updatedTimerecord,
              () => {},
              (err) => {
                this.toastr.error(err.data);
              },
            );
          },
          (err) => {
            this.toastr.error(err.data);
          },
        );

        const idx = this.timerecords.indexOf(updatedTimerecord);
        this.timerecords.splice(idx, 1);
      } else {
        updatedTimerecord.date = theMoment.format();
        updatedTimerecord.duration = duration;
        this.Timerecord.update(
          updatedTimerecord,
          () => {},
          (err) => {
            this.toastr.error(err.data);
          },
        );
      }
    }

    updatedTimerecord.dragged = false;
  }

  private createOrIncreaseTimerecord(theMoment, duration, activity) {
    let timerecord;
    const existingTimerecord = this.findExistingTimerecord(
      theMoment,
      activity,
    );

    if (existingTimerecord) {
      timerecord = existingTimerecord;
      timerecord.duration += duration;

      this.Timerecord.update(
        timerecord,
        (result) => {
          timerecord.id = result.id;
        },
        (err) => {
          this.toastr.error(err.data);
        },
      );
    } else {
      timerecord = this.Timerecord.create({
        member: this.selectedUser,
        date: theMoment.format(),
        activity: activity,
        duration: duration,
        comment: '',
      });

      this.timerecords.push(timerecord);

      this.Timerecord.save(
        timerecord,
        (result) => {
          timerecord.id = result.id;
        },
        (err) => {
          this.toastr.error(err.data);
        },
      );
    }
  }

  dropOnWeek = (event) => {
    const dataAndType = toDragDataAndType(event);
    const activity = dataAndType.data;

    for (const dayNum in this.week.days) {
      const day = this.week.days[dayNum];

      if (!day.isHoliday) {
        const duration = 100 - this.totalDuration(day.moment.day());

        if (duration > 0) {
          this.createOrIncreaseTimerecord(day.moment, duration, activity);
        }
      }
    }
  };

  dragOverTrash = (event) => {
    const type = toDragType(event);

    if (type !== 'application/x-timerecord.timerecord+json') {
      event.dataTransfer.dropEffect = 'none';
    }
  };

  dropOnTrash = (event) => {
    const jsonData = toDragDataAndType(event).data;
    const timerecord = this.timerecords.filter(function (element) {
      return element.id === jsonData.id;
    })[0];

    const idx = this.timerecords.indexOf(timerecord);
    this.timerecords.splice(idx, 1);

    this.Timerecord.remove(
      timerecord,
      () => {},
      () => {
        this.timerecords.push(timerecord);
      },
    );
  };

  editComment(originalTimerecord) {
    const timerecord = angular.copy(originalTimerecord);
    const modalInstance = this.$modal.open({
      animation: true,
      template: require('./update-comment-modal.html'),
      windowClass: 'update-comment-modal',
      controller: 'UpdateCommentModalController',
      resolve: {
        timerecord: function () {
          return timerecord;
        },
        memberId: () => {
          return this.selectedUser.id;
        },
      },
    });

    modalInstance.result.then(
      (updatedTimerecord) => {
        this.Timerecord.update(updatedTimerecord, function () {
          angular.copy(updatedTimerecord, originalTimerecord);
        });
      },
      () => {
        //Modal dismissed
      },
    );
  }

  open() {
    this.status.opened = true;
  }

  disabled(date, mode) {
    return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6);
  }
}

export const WeeklyTimesheetComponent = {
  template: weeklyTimesheetTemplate,
  controller: WeeklyTimesheetController,
};
